import React from 'react';

const StartIcon = () => (
  <svg
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 13.4999C22.5008 13.8394 22.4138 14.1734 22.2473 14.4693C22.0808 14.7652 21.8406 15.0131 21.55 15.1886L3.54 26.2061C3.23636 26.3921 2.88858 26.4936 2.5326 26.5002C2.17661 26.5068 1.82532 26.4182 1.515 26.2436C1.20764 26.0718 0.951595 25.8212 0.773205 25.5176C0.594814 25.2139 0.500514 24.8683 0.5 24.5161V2.48364C0.500514 2.1315 0.594814 1.78585 0.773205 1.48223C0.951595 1.17862 1.20764 0.927995 1.515 0.756142C1.82532 0.581577 2.17661 0.493018 2.5326 0.499611C2.88858 0.506203 3.23636 0.607708 3.54 0.793642L21.55 11.8111C21.8406 11.9867 22.0808 12.2345 22.2473 12.5305C22.4138 12.8264 22.5008 13.1604 22.5 13.4999Z"
      fill="white"
    />
  </svg>
);

export default StartIcon;
